import { createFileRoute } from '@tanstack/react-router'

import { Dashboards } from '@/widgets/dashboards'

export const Route = createFileRoute('/_app/')({
  component: RouteComponent,
})

export const DashboardsRoute = Route

function RouteComponent() {
  return <Dashboards />
}
